import { type Color } from '@air/primitive-color-picker';
import { type CustomFieldColor } from '@air/types';

export const mapCustomFieldColorToPickerColor = (color: CustomFieldColor): Color => ({
  id: color.id,
  name: color.name,
  hex: color.backgroundHex,
});
